import React from 'react';
import { Box } from '@mui/material';
import { CurrentTransports } from '../../charts/CurrentTransports';

export function CurrentTransportsWidget() {
  return (
    <Box>
      <CurrentTransports />
    </Box>
  );
}
